<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Loyal to the Sky</title>
<link href="CSS_1.css" rel="stylesheet" type="text/css"/>
<div class="chapter" id="d14e135">
<p id="d7e2958"><br/> You come and go. The doors swing closed <br/> ever more gently, almost without a shudder. <br/> Of all who move through the quiet houses, <br/> you are the quietest.<br/><br/></p>
<p id="d7e3138"><br/> We become so accustomed to you, <br/> we no longer look up <br/> when your shadow falls over the book we are reading <br/> and makes it glow. For all things <br/> sing you: at times <br/> we just hear them more clearly.<br/><br/></p>
<p id="d7e3368"><br/> Often when I imagine you <br/> your wholeness cascades into many shapes. <br/> You run like a herd of luminous deer <br/> and I am dark, I am forest.<br/><br/></p>
<p id="d7e3548"><br/> You are a wheel at which I stand, <br/> whose dark spokes sometimes catch me up, <br/> revolve me nearer to the center. <br/> Then all the work I put my hand to <br/> widens from turn to turn.<br/><br/></p>
<p class="center" id="d7e3778"><span><span class="small">I, </span>45 from <i>Rilke’s Book of Hours: Love Poems to God;</i><br/> translation by Joanna Macy and Anita Barrows</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abc.vue?4fa0238e